<div class="d-flex align-items-center px-6 py-4 admin-header">
  <h5 class="h5 bold flex-grow-1 mb-0">Alerts &amp; Notifications</h5>
  <gcc-search-input #search="gccSearchInput" placeholder="Search by title"></gcc-search-input>
  <button type="button" class="btn btn-primary ml-4 btn-add" (click)="handleAddItem()">Add</button>
</div>
<gcc-grid [dataSource]="dataSource" [searchInput]="search" trackByProp="id" class="p-4 alerts-and-notifications">
  <gcc-empty-state-wrapper
    class="flex-grow-1"
    [heading]="'common.messages.no_records' | translate"
  ></gcc-empty-state-wrapper>
</gcc-grid>
<ng-template #country let-item="item">
  {{ item.countryName }}
</ng-template>
<ng-template #actions let-item="item">
  <div class="dropdown" bsDropdown>
    <button type="button" class="btn btn-icon" dropdownToggle><i class="icon icon-more"></i></button>
    <ul class="dropdown-menu dropdown-menu-right" role="menu" *dropdownMenu>
      <li role="menuitem">
        <a
          class="d-flex align-items-center px-4 py-2 dropdown-item"
          href="javascript:void(0)"
          (click)="handleEditNotification(item)"
        >
          <i class="icon icon-edit-line icon-16 mr-2"></i>
          <span class="flex-grow-1">Edit</span>
        </a>
      </li>
      @if (item.status === notificationStatus.Draft) {
        <li role="menuitem">
          <a
            class="d-flex align-items-center px-4 py-2 dropdown-item"
            href="javascript:void(0)"
            (click)="handleDeleteItem(item)"
          >
            <i class="icon icon-delete icon-16 mr-2"></i>
            <span class="flex-grow-1">Delete</span>
          </a>
        </li>
      }
      <li role="menuitem">
        <a
          class="d-flex align-items-center px-4 py-2 dropdown-item"
          href="javascript:void(0)"
          (click)="handleCopyItem(item)"
        >
          <i class="icon icon-copy icon-16 mr-2"></i>
          <span class="flex-grow-1">Copy</span>
        </a>
      </li>
      @if (item.status == notificationStatus.Draft) {
        <li role="menuitem">
          <a
            class="d-flex align-items-center px-4 py-2 dropdown-item"
            href="javascript:void(0)"
            (click)="handlePublishItem(item)"
          >
            <i class="icon icon-tick icon-16 mr-2"></i>
            <span class="flex-grow-1">Publish</span>
          </a>
        </li>
      }
      @if (item.status == notificationStatus.Published) {
        <li role="menuitem">
          <a
            class="d-flex align-items-center px-4 py-2 dropdown-item"
            href="javascript:void(0)"
            (click)="handleArchiveItem(item)"
          >
            <i class="icon icon-archive icon-16 mr-2"></i>
            <span class="flex-grow-1">Archive</span>
          </a>
        </li>
      }
    </ul>
  </div>
</ng-template>
<ng-template #publish let-item="item">
  {{ item.publishDate | dateFormat }}
  @if (!item.publishDate) {
    <a href="javascript:void(0)" (click)="onPublishClick($event, item)" class="bold">Publish</a>
  }
</ng-template>
